import Http from '../http'

export default {

  index(filters) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`
    return Http.get(`/employees`, {params: {...filters}})
  },

  // current_employee(id){
  //   return Http.get(`/employees/current_employee/${id}`);
  // },

  create(employee){
    return Http.post(`/employees`, {employee: {...employee}})
  },

  update(employee){
    return Http.put(`/employees/${employee.id}`, {
      employee: {...employee},
    });
  },

  updateUser(user){
    return Http.put(`/users/${user.id}`, {
      user: {
        ...user,
        // cpf: user.cpf.replace(/[\W]/g, ""),
      },
    });
  },

  show(id) {
    return Http.get(`/employees/${id}`);
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }

}
